/**
 * Check Circle
 * Reusable green/empty check circle that is used in place
 * of checkboxes in some views
 */
import React from 'react';

import Icon from '@components/Icon/Icon';

import { CheckCircleStyle } from './CheckCircle.style';

const CheckCircle: React.FC<{
  selected?: boolean;
  size?: number;
  onClick?: () => void;
}> = ({ selected = false, size = 25, onClick }) => (
  <CheckCircleStyle onClick={onClick} selected={selected} size={size}>
    {selected ? (
      <Icon
        color="primary.main"
        name="circle-check"
        style={{ fontSize: size }}
      />
    ) : null}
  </CheckCircleStyle>
);

export default CheckCircle;
